import React, { useRef } from 'react';
import { X } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { formatBytes } from '@/config/adminVideoUpload';

/** ファイル添付1件分。選択済みのファイル名・サイズと、任意項目の解除ボタンを持つ。 */
export default function AdminVideoFileField({
  id,
  label,
  hint,
  accept,
  file,
  required = false,
  error = null,
  disabled = false,
  onChange,
  children,
}) {
  const inputRef = useRef(null);

  const handleClear = () => {
    if (inputRef.current) inputRef.current.value = '';
    onChange(null);
  };

  return (
    <div>
      <Label htmlFor={id} className="mb-2 block text-sm font-medium text-[#2d1810]">
        {label}
        {required ? (
          <span className="ml-1 text-xs font-normal text-[#b4462f]">必須</span>
        ) : (
          <span className="ml-1 text-xs font-normal text-[#8b6f47]">任意</span>
        )}
      </Label>

      <input
        id={id}
        ref={inputRef}
        type="file"
        accept={accept}
        disabled={disabled}
        onChange={(event) => onChange(event.target.files?.[0] ?? null)}
        className="block w-full cursor-pointer rounded-lg border border-[#d4c4b0] bg-[#f5ede3] px-3 py-2 text-sm text-[#5d4529] file:mr-3 file:cursor-pointer file:rounded-md file:border-0 file:bg-[#8b6f47] file:px-3 file:py-1.5 file:text-xs file:font-medium file:text-[#f5ede3] hover:file:bg-[#6b5540] disabled:cursor-not-allowed disabled:opacity-60"
      />

      {hint && <p className="mt-1 text-xs text-[#8b6f47]">{hint}</p>}

      {file && (
        <div className="mt-2 flex flex-wrap items-center gap-2 rounded-lg bg-[#faf6f1] px-3 py-2 text-xs text-[#5d4529]">
          <span className="min-w-0 break-all font-medium">{file.name}</span>
          <span className="text-[#8b6f47]">{formatBytes(file.size)}</span>
          {!required && !disabled && (
            <button
              type="button"
              onClick={handleClear}
              className="ml-auto inline-flex items-center gap-1 text-[#8b6f47] transition-colors hover:text-[#2d1810]"
            >
              <X className="h-3 w-3" />
              解除
            </button>
          )}
        </div>
      )}

      {children}

      {error && <p className="mt-1 text-xs text-[#b4462f]">{error}</p>}
    </div>
  );
}
